<template>
    <div class="dispatcher-workplace-container">
        <div class="dispatcher-workplace-container__content">
            <template v-if="$slots['sidebar']">
                <slot name="sidebar" />
            </template>

            <main class="content__main">
                <slot></slot>
            </main>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.dispatcher-workplace-container {
    &__content {
        min-height: calc(100vh - 70px);
        position: relative;
    }
}
</style>